"use client";

import { useQuery } from "@tanstack/react-query";
import {
  getUserDashboardActiveValidatorsAction,
  getUserDashboardPerformanceSummaryAction,
  getUserDashboardStatisticsAction,
} from "@/resources/actions/user.actions";
import { queryKeys } from "@/lib/query-keys";

export function useUserDashboard(wallet?: string) {
  const activeValidatorsQuery = useQuery({
    queryKey: queryKeys.userDashboard.activeValidators(wallet ?? ""),
    queryFn: async () => {
      const result = await getUserDashboardActiveValidatorsAction(wallet ?? "");
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    enabled: !!wallet,
    staleTime: 500, // 500ms
  });

  const performanceSummaryQuery = useQuery({
    queryKey: queryKeys.userDashboard.performanceSummary(wallet ?? ""),
    queryFn: async () => {
      const result = await getUserDashboardPerformanceSummaryAction(
        wallet ?? "",
      );
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    enabled: !!wallet,
    staleTime: 500, // 500ms
  });

  const statisticsQuery = useQuery({
    queryKey: queryKeys.userDashboard.statistics(wallet ?? ""),
    queryFn: async () => {
      const result = await getUserDashboardStatisticsAction(wallet ?? "");
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    enabled: !!wallet,
    staleTime: 500, // 500ms
  });

  return {
    activeValidatorsQuery,
    performanceSummaryQuery,
    statisticsQuery,
  };
}
